export const hasValues = (value: number | string, ...values: (number | string)[]): boolean =>
	values.reduce((acc: boolean, v: number | string) => {
		if (acc) return acc;
		if (v === value) return true; else return acc;
	}, false);

export const hasNotValues = (value: number | string, ...values: (number | string)[]): boolean =>
	!hasValues(value, ...values);